import axios from "axios";

const API_URL =
  process.env.NODE_ENV !== "production"
    ? "https://we-village-api.onrender.com/"
    : "https://we-village-api.onrender.com/";

const register = (username, email, password, userRole) => {
  return axios.post(API_URL + "api/user/signIn", {
    name: username,
    email: email,
    password: password,
    role: userRole,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "api/user/login", {
      email: username,
      password,
    })
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem(
          "token",
          JSON.stringify(response.data?.token)
        );
         localStorage.setItem(
          "adamId",
          JSON.stringify(response.data?.user?._id)
        );
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("token");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("D_User"));
};
const getCurrentUserTokken = () => {
  return JSON.parse(localStorage.getItem("token"));
};
const getCurrentUserRole = () => {
  return JSON.parse(localStorage.getItem("bk_role"));
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  getCurrentUserTokken,
  getCurrentUserRole
};

export default AuthService;
